export default {
    listagem: {
        titulo_pagina: 'Logs de Auditoria'
    },
    filtro: {
        evento: 'Evento',
        modelo: 'Modelo',
        chave_modelo: 'Chave do Modelo',
        veus_id: 'Veus Id',
        usuario: 'Usuário',
        periodo_padrao: 'Período Padrão',
        periodo_personalizado: 'Período Personalizado',
        mais_filtros: 'Mais Filtros',
        filtrar_button: 'Filtrar',
        limpar_button: 'Limpar Filtros'
    },
    periodos: {
        trinta_minutos: '30 minutos atrás',
        uma_hora: '1 hora atrás',
        hoje: 'Hoje',
        sete_dias: 'Últimos 7 dias',
        mes_atual: 'Mês atual',
        mes_anterior: 'Mês anterior',
        ano_atual: 'Ano atual',
        ano_anterior: 'Ano anterior'
    },
    tabela: {
        campos: {
            evento: 'Evento',
            modelo: 'Modelo',
            chave_modelo: 'Chave do Modelo',
            veus_id: 'Veus Id',
            usuario: 'Usuário',
            criado_em: 'Criado Em',
            atualizado_em: 'Atualizado Em',
            valores_antigos: 'Valores Antigos',
            novos_valores: 'Novos Valores',
            ip: 'IP',
            user_agent: 'User Agent',
            url: 'URL',
            tags: 'Tags'
        }
    },
    detail: {
        titulo_pagina: "Logs de Auditoria"
    }
}
